import styled from 'styled-components';
import { roleColorSVG } from '@/pages/CompanyReport/components/InsiderTradingTransactions/components/Roles';

export const Role = styled('div')`
  position: relative;
  padding-left: 28px;
  > svg {
    ${roleColorSVG}
    position: absolute;
    top: -1px;
    left: 0;
    width: 20px;
    height: 20px;
  }
  margin-top: ${({ theme }) => theme.x1spacePx}px;
  &:first-child {
    margin-top: 0;
  }
`;
